import * as React from "react";
const SvgUnselectedRadio = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 7.5, stroke: "#AEABB6" }));
export default SvgUnselectedRadio;
